var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-panel"},[_c('el-collapse',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"title":_vm.$t(`nav.pMenu.mask`),"name":"1"}},[_c('div',{staticClass:"detail-item flex-rowl",class:{
          'detail-item': true,
          'flex-rowl': true,
          active: _vm.isActive('detail1'),
        },on:{"click":function($event){return _vm.goToProductPage('detail1')}}},[_vm._v(" "+_vm._s(_vm.$t(`nav.pMenu.mask1`))+" ")]),_c('div',{staticClass:"detail-item flex-rowl",class:{
          'detail-item': true,
          'flex-rowl': true,
          active: _vm.isActive('detail2'),
        },on:{"click":function($event){return _vm.goToProductPage('detail2')}}},[_vm._v(" "+_vm._s(_vm.$t(`nav.pMenu.mask2`))+" ")])]),_c('el-collapse-item',{attrs:{"title":_vm.$t(`nav.pMenu.elastic`),"name":"2"}},[_c('div',{staticClass:"detail-item flex-rowl",class:{
          'detail-item': true,
          'flex-rowl': true,
          active: _vm.isActive('detail3'),
        },on:{"click":function($event){return _vm.goToProductPage('detail3')}}},[_vm._v(" "+_vm._s(_vm.$t(`nav.pMenu.elastic1`))+" ")]),_c('div',{staticClass:"detail-item flex-rowl",class:{
          'detail-item': true,
          'flex-rowl': true,
          active: _vm.isActive('detail4'),
        },on:{"click":function($event){return _vm.goToProductPage('detail4')}}},[_vm._v(" "+_vm._s(_vm.$t(`nav.pMenu.elastic2`))+" ")]),_c('div',{staticClass:"detail-item flex-rowl",class:{
          'detail-item': true,
          'flex-rowl': true,
          active: _vm.isActive('detail5'),
        },on:{"click":function($event){return _vm.goToProductPage('detail5')}}},[_vm._v(" "+_vm._s(_vm.$t(`nav.pMenu.elastic3`))+" ")])]),_c('el-collapse-item',{attrs:{"title":_vm.$t(`nav.pMenu.essence`),"name":"3"}},[_c('div',{staticClass:"detail-item flex-rowl",class:{
          'detail-item': true,
          'flex-rowl': true,
          active: _vm.isActive('detail6'),
        },on:{"click":function($event){return _vm.goToProductPage('detail6')}}},[_vm._v(" "+_vm._s(_vm.$t(`nav.pMenu.essence1`))+" ")]),_c('div',{staticClass:"detail-item flex-rowl",class:{
          'detail-item': true,
          'flex-rowl': true,
          active: _vm.isActive('detail7'),
        },on:{"click":function($event){return _vm.goToProductPage('detail7')}}},[_vm._v(" "+_vm._s(_vm.$t(`nav.pMenu.essence2`))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }